// extracted by mini-css-extract-plugin
export default {"container":"G3y2ZCtyGsrOH5w1fiHL"};